/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * @author Yann Massard (yamass@gmail.com)
 */

import * as Mustache from "mustache";
import {UiLocalTimeFieldConfig, UiLocalTimeFieldSubCommandHandler, UiLocalTimeFieldSubEventSource} from "../../../generated/UiLocalTimeFieldConfig";
import {TeamAppsUiContext} from "../../TeamAppsUiContext";
import {TeamAppsUiComponentRegistry} from "../../TeamAppsUiComponentRegistry";
import {AbstractUiTimeField} from "./AbstractUiTimeField";
import {arraysEqual} from "../../Common";

type LocalTime = [number, number, number, number];

export class UiLocalTimeField extends AbstractUiTimeField<UiLocalTimeFieldConfig, LocalTime> implements UiLocalTimeFieldSubEventSource, UiLocalTimeFieldSubCommandHandler {

	protected initialize(config: UiLocalTimeFieldConfig, targetElement: Element, context: TeamAppsUiContext) {
		super.initialize(config, targetElement, context);
		this.getMainDomElement().addClass("UiLocalTimeField");
	}

	isValidData(v: LocalTime): boolean {
		return v == null || (Array.isArray(v) && typeof v[0] === "number" && typeof v[1] === "number");
	}

	protected displayCommittedValue(): void {
		let uiValue = this.getCommittedValue();
		if (uiValue) {
			this.trivialComboBox.setSelectedEntry(UiLocalTimeField.createTimeComboBoxEntry(uiValue[0], uiValue[1], this.getTimeFormat()), true);
		} else {
			this.trivialComboBox.setSelectedEntry(null, true);
		}
	}

	public getTransientValue(): LocalTime {
		let selectedEntry = this.trivialComboBox.getSelectedEntry();
		if (selectedEntry) {
			return [selectedEntry.hour, selectedEntry.minute, 0, 0];
		} else {
			return null;
		}
	}

	public static getReadOnlyHtml(config: UiLocalTimeFieldConfig, value: LocalTime, context: TeamAppsUiContext, drawBorder: boolean): string {
		if (value != null && value != null) {
			return `<div class="static-readonly-UiLocalTimeField ${drawBorder ? "bordered" : ""}">` + Mustache.render(UiLocalTimeField.comboBoxTemplate, UiLocalTimeField.createTimeComboBoxEntry(value[0], value[1], config.timeFormat || context.config.timeFormat)) + '</div>';
		} else {
			return "";
		}
	}

	public valuesChanged(v1: LocalTime, v2: LocalTime): boolean {
		return !arraysEqual(v1, v2);
	}
}

TeamAppsUiComponentRegistry.registerFieldClass("UiLocalTimeField", UiLocalTimeField);